import React from "react";
import { StaticImage } from "gatsby-plugin-image";

export default function SplashScreen({ isExiting }) {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        background: "linear-gradient(135deg, #003da5 20%, #001d48 80%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        opacity: isExiting ? 0 : 1,
        transition: "opacity 0.9s ease-in-out 0.8s",
      }}
    >
      <style>{`
        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 0.85; }
          50%      { transform: scale(1.05); opacity: 1; }
        }

        @keyframes logoZoom {
          0%   { transform: scale(1);    opacity: 1; filter: brightness(1)   blur(0); }
          30%  { transform: scale(1.15); opacity: 1; filter: brightness(1.8) blur(0); }
          60%  { transform: scale(2.5);  opacity: 1; filter: brightness(3)   blur(2px); }
          85%  { transform: scale(12);   opacity: 0.6; filter: brightness(4) blur(6px); }
          100% { transform: scale(18);   opacity: 0; filter: brightness(5)   blur(12px); }
        }

        @keyframes glowFlare {
          0%   { opacity: 0; transform: scale(0.5); }
          40%  { opacity: 0.7; transform: scale(1.2); }
          100% { opacity: 0; transform: scale(3); }
        }
      `}</style>

      <div
        style={{
          position: "absolute",
          width: "300px",
          height: "300px",
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(0,61,165,0.8) 0%, transparent 70%)",
          opacity: 0,
          pointerEvents: "none",
          animation: isExiting ? "glowFlare 1s ease-out forwards" : "none",
        }}
      />
      <div
        style={{
          maxWidth: "150px",
          animation: isExiting
            ? "logoZoom 1.2s cubic-bezier(0.4, 0, 0.2, 1) forwards"
            : "pulse 1.6s ease-in-out infinite",
        }}
      >
        <StaticImage
          src="../../src/assets/logos/remax-logo.png"
          alt="REMAX Capital"
        />
      </div>
    </div>
  );
}
